<template>
  <div>
    <div class="waf-title">
      <div>{{ $t("RAM.ALI.Waf.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="['resourceConfigurationManagement:ali:waf:update']"
          :loading="modal_loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="['resourceConfigurationManagement:ali:waf:export']"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="waf-top">
      <web-application-firewall-search
        ref="search"
      ></web-application-firewall-search>
    </div>
    <table-web-application-firewall></table-web-application-firewall>
  </div>
</template>

<script>
import WebApplicationFirewallSearch from "../waf/WebApplicationFirewallSearch";
import TableWebApplicationFirewall from "../waf/TableWebApplicationFirewall";

export default {
  name: "Waf",
  components: {
    WebApplicationFirewallSearch,
    TableWebApplicationFirewall
  },
  data() {
    return {
      modal_loading: false,
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.companyId = this.$refs.search.companyId;

      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 307,
          accountType: 1
        })
        .then(res => {
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });

      // 获取子组件数据
      this.companyId = this.$refs.search.companyId;
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAliWaf({
          companyId: this.companyId,
          accountName: this.accountName
        })
        .then(res => {
          let fileName = "waf.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.waf-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.waf-title > div:nth-child(1) {
  float: left;
}
.waf-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.waf-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/waf/Waf.vue